import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Button } from "react-bootstrap";
import moment from "moment";

class OccupationList extends Component {
  render() {
    const { action, isStaffApp, newOccupation, editOccupation } = this.props;
    const occupations = this.props.occupations.filter((o) => !o._destroy);

    return (
      <Table size="sm" responsive>
        <thead>
          <tr>
            <th>Employer</th>
            <th>Position</th>
            <th>Gross monthly</th>
            <th>Gross Annual</th>
            <th>Date Reported</th>
            <th>Started At</th>
            <th>Ended At</th>
            <th>Notes</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            occupations.map((o) => {
              return (
                <tr key={o.id}>
                  <td>{o.employer}</td>
                  <td>{o.position}</td>
                  <td>{parseFloat(o.income/12).toFixed(2)}</td>
                  <td>{o.income}</td>
                  <td>{o.date_reported && moment(o.date_reported).format("MM/DD/YYYY")}</td>
                  <td>{o.started_at && moment(o.started_at).format("MM/DD/YYYY")}</td>
                  <td>{o.ended_at && moment(o.ended_at).format("MM/DD/YYYY")}</td>
                  <td>{o.notes}</td>
                  <td>
                    {
                      action === "edit" &&
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.editOccupation(o);
                        }}>
                        Edit
                      </a>
                    }
                  </td>
                </tr>
              );
            })
          }
          {
            action == "edit" &&
            <tr>
              <td colSpan={8} className="text-center">
                <Button
                  variant="link"
                  onClick={() => {
                    this.props.newOccupation();
                  }}>
                  Add Employment History
                </Button>
              </td>
            </tr>
          }
        </tbody>
      </Table>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isStaffApp: state.config.isStaffApp,
    occupations: state.occupations,
    action: state.ui.action
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    newOccupation: () => {
      dispatch({
        type: "NEW_RESOURCE",
        payload: { resourceName: "occupation" }
      })
    },
    editOccupation: (resource) => {
      dispatch({
        type: "EDIT_RESOURCE",
        payload: { resourceName: "occupation", resource }
      })
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OccupationList);
